// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_kh-0";
export var fulfillmentPanelBody = "_kh-1";